import { syncLoginState } from "@central/loginer";
import { updateHeader } from "@picwish/header";
import store from "@/store/main";
import Storage from "@/utils/storage";

export const thirdLogin = () => {
  return syncLoginState({
    onLogin(data) {
      const { api_token, identity_token, user } = data.data;
      Storage.set("account_api_token", api_token);
      Storage.set("account_user", user);
      Storage.set("account_id_token", identity_token);
      store.dispatch("UpdateApiToken", api_token);
      store.dispatch("UpdateUserInfo", user);
      store.dispatch("UpdateIdentityToken", identity_token);
      updateHeader();

      // 退出登录触发vuex
      setTimeout(() => {
        const el = document.querySelector(".headerUserInfo > span");
        if (el) {
          el.addEventListener("click", () => {
            store.dispatch("Logout");
          });
        }
      }, 0);
    },
  });
};
